import type { ExtendData } from '../api/types';

export interface HistoryData extends ExtendData {
  time: number;
}

export const HISTORY_LIMIT = 10;

export function historySnapshot(data: ExtendData): ExtendData {
  const duration = Math.max(1, Number(data.encounter?.durationSeconds) || 0);
  const perSecond = (amount: number, fallback: number) =>
    amount > 0 ? Math.trunc(amount / duration) : fallback;
  const combatant = data.combatant.map((player) => ({
    ...player,
    dps: perSecond(player.damage, player.dps),
    hps: perSecond(player.healed, player.hps),
    rdpsGivenByBuff: (player.rdpsGivenByBuff ?? []).map((row) => ({ ...row })),
    rdpsReceivedByBuff: (player.rdpsReceivedByBuff ?? []).map((row) => ({ ...row })),
  }));
  return {
    ...data,
    encounter: {
      ...data.encounter,
      dps: perSecond(data.encounter.damage, data.encounter.dps),
      hps: perSecond(data.encounter.healed, data.encounter.hps),
    },
    combatant,
    limitBreak: data.limitBreak
      ? {
          ...data.limitBreak,
          dps: perSecond(data.limitBreak.damage, data.limitBreak.dps),
          hps: perSecond(data.limitBreak.healed, data.limitBreak.hps),
        }
      : undefined,
  };
}

export function prependHistory(
  history: readonly HistoryData[],
  data: ExtendData,
  time = Date.now()
): HistoryData[] {
  return [{ time, ...historySnapshot(data) }, ...history].slice(0, HISTORY_LIMIT);
}
